import { Link } from "react-router-dom";
import { signInWithGoogle } from "../../services/LoginService";
import { Grid } from "@mui/material";
import Typography from "@mui/material/Typography";

import style from "./Explore_4.module.css";
// import Login from "../../components/login/Login";
import GrayBtn from "../../components/button/GrayBtn";
import WhiteBtn from "../../components/button/WhiteBtn";

function Explore_4() {
  return (
    <div style={{ height: "100%" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "calc(100vh - 100px)",
        }}
      >
        <Grid className={style.wordsbox}>
          <Typography variant="h7">準備好上路創業高速公路了嗎？</Typography>
        </Grid>
        <Grid className={style.btnbox}>
          <GrayBtn
            variant="h5"
            onClick={signInWithGoogle}
            className={style.leftbutton}
          >
            是，登入平台
          </GrayBtn>
          <Link to="/">
            <WhiteBtn variant="h5" className={style.MainBtn}>
              否，返回主頁
            </WhiteBtn>
          </Link>
        </Grid>
      </div>
    </div>
  );
}

export default Explore_4;
